export const siteInfo = {
  name: '探花系列',
  tagline: '国产探花资源聚合平台',
  slogan: '每日精选 · 高清在线 · 海量探花视频作品合集',
  intro:
    '探花系列是国内领先的国产探花资源聚合平台，专注收录全网最新、最全的探花视频作品。我们从海量内容中严选优质探花系列资源，确保每部作品高清流畅，为探花爱好者提供一站式免费在线观看体验。平台每日更新，覆盖国产果冻传媒探花、街拍探花、酒店探花等热门专题，打造本土探花资源最全入口。',
  stats: [
    { label: '每日更新', value: '50+ 部' },
    { label: '高清资源库', value: '20000+ 部' },
    { label: '活跃爱好者', value: '100万+' },
  ],
  primaryCta: { text: '立即浏览精选', href: '#cards' },
  secondaryCta: { text: '探索专题合集', href: '#index' },
};

export const headerNav = [
  { label: '首页', href: '#hero' },
  { label: '最新动态', href: '#updates' },
  { label: '平台特色', href: '#features' },
  { label: '专题合集', href: '#index' },
  { label: '热门榜单', href: '#ranking' },
  { label: '焦点专题', href: '#carousel' },
  { label: '常见问答', href: '#faq' },
];

export const cardsData = [
  {
    id: 'card-1',
    title: '国产果冻传媒探花·精选辑',
    desc: '果冻传媒联合出品的高清探花系列，精致拍摄与真实互动并存，每一部都是精心制作的探花佳作。',
    tag: '热门推荐',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20cinematic%20photography%20with%20warm%20amber%20lighting%2C%20soft%20shadows%2C%20elegant%20composition%2C%20moody%20atmosphere%2C%20dark%20background%20with%20subtle%20texture%2C%20professional%20lighting%20setup%2C%20film%20noir%20aesthetic&width=800&height=500&seq=tanhua-card-01&orientation=landscape',
  },
  {
    id: 'card-2',
    title: '街拍探花·城市邂逅系列',
    desc: '都市街拍风格探花视频，记录城市夜晚的真实邂逅，自然光线下的亲密互动，原汁原味的本土探花体验。',
    tag: '街拍专题',
    image: 'https://readdy.ai/api/search-image?query=Urban%20night%20street%20photography%2C%20warm%20neon%20lights%2C%20shallow%20depth%20of%20field%2C%20cinematic%20mood%2C%20dark%20alley%20aesthetic%2C%20soft%20bokeh%2C%20atmospheric%20night%20scene&width=800&height=500&seq=tanhua-card-02&orientation=landscape',
  },
  {
    id: 'card-3',
    title: '酒店探花·私密空间系列',
    desc: '高端酒店私密空间探花系列，专业灯光布景下的真实拍摄，沉浸式观看体验，百万爱好者首选合集。',
    tag: '酒店专题',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20hotel%20room%20interior%20with%20warm%20ambient%20lighting%2C%20soft%20curtains%2C%20elegant%20decor%2C%20cinematic%20lighting%2C%20moody%20atmosphere%2C%20professional%20interior%20photography&width=800&height=500&seq=tanhua-card-03&orientation=landscape',
  },
  {
    id: 'card-4',
    title: '素人探花·真实体验系列',
    desc: '非专业演员的真实探花体验，自然的互动与真实反应，呈现最原生的国产探花内容，深受爱好者好评。',
    tag: '素人精选',
    image: 'https://readdy.ai/api/search-image?query=Natural%20portrait%20photography%20with%20soft%20window%20light%2C%20warm%20tones%2C%20intimate%20atmosphere%2C%20cinematic%20composition%2C%20shallow%20depth%20of%20field%2C%20cozy%20indoor%20setting&width=800&height=500&seq=tanhua-card-04&orientation=landscape',
  },
  {
    id: 'card-5',
    title: '多人探花·派对狂欢系列',
    desc: '多人互动探花派对合集，热闹氛围与精彩互动，突破传统探花模式，带来更丰富的观看体验。',
    tag: '派对系列',
    image: 'https://readdy.ai/api/search-image?query=Warm%20social%20gathering%20atmosphere%2C%20dim%20ambient%20lighting%2C%20candlelit%20setting%2C%20cinematic%20group%20scene%2C%20soft%20focus%2C%20elegant%20party%20lighting%2C%20moody%20aesthetic&width=800&height=500&seq=tanhua-card-05&orientation=landscape',
  },
  {
    id: 'card-6',
    title: '最新探花·本周热播合集',
    desc: '本周最新上架的探花视频精选，紧跟热点更新，不错过任何一部热门国产探花作品，每日刷新推荐。',
    tag: '本周新番',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20reel%20aesthetic%2C%20warm%20vintage%20tones%2C%20projector%20light%2C%20dark%20cinema%20atmosphere%2C%20soft%20film%20grain%2C%20nostalgic%20mood%2C%20professional%20lighting&width=800&height=500&seq=tanhua-card-06&orientation=landscape',
  },
];

export const featuresData = [
  {
    id: 'feat-1',
    icon: 'ri-shield-check-line',
    title: '高清画质保障',
    desc: '全站探花视频采用高清编码技术，确保每一帧画面清晰流畅，为探花爱好者带来影院级观看享受。',
  },
  {
    id: 'feat-2',
    icon: 'ri-refresh-line',
    title: '每日实时更新',
    desc: '专业团队7×24小时持续收录最新国产探花资源，每日50+部更新量，保证探花入口内容始终新鲜。',
  },
  {
    id: 'feat-3',
    icon: 'ri-smartphone-line',
    title: '全平台畅享',
    desc: '完美适配桌面端与移动端，随时随地打开浏览器即可免费在线观看国产探花系列，无需安装任何应用。',
  },
  {
    id: 'feat-4',
    icon: 'ri-vip-crown-line',
    title: '精选严审机制',
    desc: '每部探花作品均经过人工筛选与质量审核，剔除低质重复内容，只保留值得观看的探花精品合集。',
  },
];

export const indexData = [
  { id: 'idx-1', title: '国产果冻传媒探花', count: 3286, tag: '热门' },
  { id: 'idx-2', title: '酒店探花实录', count: 2519, tag: '新番' },
  { id: 'idx-3', title: '街拍探花合集', count: 1892, tag: '经典' },
  { id: 'idx-4', title: '素人探花体验', count: 2105, tag: '推荐' },
  { id: 'idx-5', title: '多人探花派对', count: 967, tag: '火爆' },
  { id: 'idx-6', title: '剧情探花系列', count: 1534, tag: '精选' },
  { id: 'idx-7', title: '直播探花回放', count: 4218, tag: '最热' },
  { id: 'idx-8', title: '经典探花回顾', count: 6780, tag: '珍藏' },
];

export const contactData = {
  title: '投稿与合作',
  desc: '探花系列平台欢迎广大探花爱好者投稿优质资源，也期待与国产探花内容创作者建立合作关系。如果您有精彩的探花视频作品或合作意向，请通过以下方式联系我们。',
  email: 'contact@tanhuaseries.example.com',
  wechat: 'TanHua_Official',
  qq: '1234567890',
};

export const updatesData = [
  {
    id: 'upd-1',
    date: '2026-07-30',
    title: '本周探花新番上线，果冻传媒联合出品多部高清探花力作',
    desc: '本周上架国产果冻传媒探花系列最新作品共12部，涵盖酒店、街拍等多个主题，全高清画质呈现。',
    tag: '新番速递',
  },
  {
    id: 'upd-2',
    date: '2026-07-28',
    title: '平台服务器全面升级，探花视频加载速度提升300%',
    desc: '为提升探花爱好者的观看体验，平台已完成CDN节点扩容，全国范围内视频缓冲时间大幅缩短。',
    tag: '平台公告',
  },
  {
    id: 'upd-3',
    date: '2026-07-25',
    title: '街拍探花夏季特辑上线，城市夜景探花系列热度飙升',
    desc: '夏季街拍探花特辑收录了北京、上海、广州等城市的夜间探花佳作，成为近期最受欢迎的专题。',
    tag: '专题上线',
  },
  {
    id: 'upd-4',
    date: '2026-07-22',
    title: '素人探花投稿通道正式开放，优质作品可获得首页推荐',
    desc: '即日起探花爱好者可通过投稿通道提交自己的探花作品，审核通过后将获得首页推荐位曝光。',
    tag: '功能更新',
  },
  {
    id: 'upd-5',
    date: '2026-07-18',
    title: '探花系列「经典回顾」栏目改版，按年份整理历年佳作',
    desc: '经典探花回顾栏目全新改版，按年份与主题分类整理了超过6000部经典探花视频作品。',
    tag: '栏目改版',
  },
  {
    id: 'upd-6',
    date: '2026-07-15',
    title: '移动端体验优化完成，探花视频自适应播放更流畅',
    desc: '针对手机浏览器的探花视频播放体验进行了专项优化，现在移动端观看探花系列更加流畅便捷。',
    tag: '体验升级',
  },
  {
    id: 'upd-7',
    date: '2026-07-10',
    title: '探花资源库突破20000部，成为国产探花最大聚合平台',
    desc: '经过团队持续努力，平台探花视频资源总量正式突破20000部大关，稳居国产探花领域首位。',
    tag: '里程碑',
  },
];

export const rankingData = [
  { id: 'rk-1', rank: 1, title: '果冻传媒·城市猎人探花', views: '892万', trend: 'up', tag: '🔥 本周最热' },
  { id: 'rk-2', rank: 2, title: '深夜酒店·私密探花实录', views: '756万', trend: 'up', tag: '📈 飙升' },
  { id: 'rk-3', rank: 3, title: '街拍素人·真实邂逅系列', views: '634万', trend: 'up', tag: '⭐ 新上榜' },
  { id: 'rk-4', rank: 4, title: '派对狂欢·多人探花合集', views: '521万', trend: 'down', tag: '🔥 持续热门' },
  { id: 'rk-5', rank: 5, title: '剧情探花·完整故事线', views: '489万', trend: 'up', tag: '📈 上升' },
  { id: 'rk-6', rank: 6, title: '经典回顾·早期探花名作', views: '412万', trend: 'stable', tag: '💎 经典' },
];

export const commentsData = [
  {
    id: 'cmt-1',
    user: '探花老司机',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20portrait%2C%20warm%20amber%20tones%2C%20soft%20gradient%20background%2C%20simple%20geometric%20style&width=80&height=80&seq=tanhua-avatar-01&orientation=squarish',
    date: '2026-07-29',
    content: '这个探花系列平台真的太全了！之前到处找国产探花资源都零零散散的，现在终于有一个一站式入口了。画质也很清晰，加载速度也快，必须推荐给兄弟们。',
    rating: 5,
  },
  {
    id: 'cmt-2',
    user: '午夜观影人',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20profile%2C%20warm%20coral%20tones%2C%20soft%20gradient%2C%20simple%20modern%20style&width=80&height=80&seq=tanhua-avatar-02&orientation=squarish',
    date: '2026-07-28',
    content: '每天都会来刷一下探花系列更新，果冻传媒出品的探花质量确实高，拍摄手法专业多了。街拍探花那个系列也很有感觉，真实感很强。',
    rating: 5,
  },
  {
    id: 'cmt-3',
    user: '资源收藏家',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20icon%2C%20warm%20gold%20tones%2C%20soft%20gradient%20background%2C%20simple%20elegant%20style&width=80&height=80&seq=tanhua-avatar-03&orientation=squarish',
    date: '2026-07-27',
    content: '收藏夹里全是探花系列的链接，这个平台的分类做得很好，酒店、街拍、多人各类型都有，找起来特别方便。希望继续更新更多好内容。',
    rating: 4,
  },
  {
    id: 'cmt-4',
    user: '夜猫子探花',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20circle%2C%20warm%20rose%20tones%2C%20soft%20gradient%2C%20modern%20simple%20style&width=80&height=80&seq=tanhua-avatar-04&orientation=squarish',
    date: '2026-07-26',
    content: '终于找到组织了！之前一直在各种小站看探花视频，广告又多画质又差。这个探花系列平台干净清爽，而且每部都是精选的，省去了很多筛选时间。',
    rating: 5,
  },
  {
    id: 'cmt-5',
    user: '资深探花迷',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20shape%2C%20deep%20warm%20tones%2C%20soft%20gradient%20background%2C%20simple%20sophisticated%20style&width=80&height=80&seq=tanhua-avatar-05&orientation=squarish',
    date: '2026-07-25',
    content: '从果冻传媒探花开始追的，后来发现了这个探花系列平台。资源量真的惊人，经典回顾栏目里的老探花作品很多都是之前找不到的，太感动了。',
    rating: 5,
  },
];

export const mediaData = [
  {
    id: 'med-1',
    title: '果冻传媒探花·都市猎人 精选片段',
    desc: '本月最受关注的国产果冻传媒探花系列作品，高清画质呈现城市夜色中的真实探花体验。',
    duration: '32:18',
    views: '892万',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20night%20cityscape%20with%20warm%20neon%20lighting%2C%20film%20noir%20aesthetic%2C%20soft%20focus%2C%20moody%20atmosphere%2C%20dark%20urban%20scene%2C%20professional%20cinematography%20style&width=800&height=450&seq=tanhua-media-01&orientation=landscape',
  },
  {
    id: 'med-2',
    title: '酒店探花·私密时刻 完整记录',
    desc: '高端酒店环境中的探花系列佳作，专业布光下的亲密互动，沉浸式观看体验不容错过。',
    duration: '45:06',
    views: '634万',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20hotel%20suite%20with%20warm%20ambient%20lighting%2C%20cinematic%20interior%2C%20soft%20shadows%2C%20luxury%20atmosphere%2C%20professional%20photography%2C%20moody%20aesthetic&width=800&height=450&seq=tanhua-media-02&orientation=landscape',
  },
  {
    id: 'med-3',
    title: '街拍探花·城市邂逅 合集精选',
    desc: '真实街拍风格的国产探花系列，记录城市中不经意的美好邂逅，最具本土特色的探花视频。',
    duration: '28:45',
    views: '521万',
    image: 'https://readdy.ai/api/search-image?query=Urban%20street%20at%20night%20with%20warm%20streetlights%2C%20cinematic%20composition%2C%20shallow%20depth%20of%20field%2C%20atmospheric%20city%20scene%2C%20moody%20lighting%2C%20professional%20photography&width=800&height=450&seq=tanhua-media-03&orientation=landscape',
  },
];

export const topicsData = [
  { id: 'tp-1', name: '国产探花', count: '15.2万', hot: true },
  { id: 'tp-2', name: '果冻传媒探花', count: '8.9万', hot: true },
  { id: 'tp-3', name: '酒店探花', count: '6.7万', hot: true },
  { id: 'tp-4', name: '街拍探花', count: '5.4万', hot: false },
  { id: 'tp-5', name: '探花资源', count: '4.8万', hot: false },
  { id: 'tp-6', name: '素人探花', count: '3.9万', hot: false },
  { id: 'tp-7', name: '探花视频在线', count: '3.2万', hot: true },
  { id: 'tp-8', name: '探花福利入口', count: '2.8万', hot: false },
  { id: 'tp-9', name: '探花作品大全', count: '2.3万', hot: false },
];

export const carouselData = [
  {
    id: 'car-1',
    title: '果冻传媒探花·年度巨献',
    subtitle: '2026上半年最全探花合集',
    desc: '果冻传媒与探花系列联合出品的年度重量级探花视频合集，收录上半年最受好评的50部高清探花作品，涵盖酒店、街拍、多人派对等全主题覆盖。',
    tag: '年度精选',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20aesthetic%20with%20warm%20golden%20and%20crimson%20lighting%2C%20dramatic%20composition%2C%20professional%20studio%20setup%2C%20luxurious%20atmosphere%2C%20soft%20shadows%2C%20high-end%20production%20design&width=1200&height=600&seq=tanhua-carousel-01&orientation=landscape',
  },
  {
    id: 'car-2',
    title: '城市猎人·街拍探花精选',
    subtitle: '北上广深夜实拍合集',
    desc: '覆盖北京、上海、广州三大城市的街拍探花精选系列，真实记录城市夜生活中的探花故事，最具本土特色的国产探花专题。',
    tag: '城市系列',
    image: 'https://readdy.ai/api/search-image?query=Night%20cityscape%20panorama%20with%20warm%20city%20lights%2C%20cinematic%20wide%20shot%2C%20urban%20skyline%2C%20moody%20atmosphere%2C%20professional%20photography%2C%20bokeh%20lights&width=1200&height=600&seq=tanhua-carousel-02&orientation=landscape',
  },
  {
    id: 'car-3',
    title: '经典探花·五年回顾展',
    subtitle: '2021-2026探花作品典藏',
    desc: '横跨五年的经典探花视频回顾，从早期探花到最新力作，按年份整理超过6000部经典探花作品，见证国产探花系列的发展历程。',
    tag: '经典回顾',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20film%20archive%20aesthetic%2C%20warm%20sepia%20and%20amber%20tones%2C%20nostalgic%20cinema%20atmosphere%2C%20old%20movie%20posters%20collection%2C%20soft%20lighting%2C%20elegant%20display&width=1200&height=600&seq=tanhua-carousel-03&orientation=landscape',
  },
  {
    id: 'car-4',
    title: '探花派对·多人狂欢合集',
    subtitle: '高能互动探花系列',
    desc: '精选多人探花派对系列，热闹非凡的互动场面，突破传统探花模式，带来全新的视觉体验与观看乐趣，最受欢迎的探花视频类型之一。',
    tag: '派对专题',
    image: 'https://readdy.ai/api/search-image?query=Warm%20social%20celebration%20atmosphere%2C%20elegant%20party%20setting%20with%20ambient%20lighting%2C%20cinematic%20group%20scene%2C%20soft%20candlelight%2C%20luxurious%20interior%2C%20professional%20photography&width=1200&height=600&seq=tanhua-carousel-04&orientation=landscape',
  },
  {
    id: 'car-5',
    title: '素人探花·真实体验特辑',
    subtitle: '非专业素人实录系列',
    desc: '全部由真实素人参与的探花特辑，自然的互动与真实的情感流露，为探花爱好者呈现最原生态的国产探花内容，真实感拉满的观看体验。',
    tag: '素人特辑',
    image: 'https://readdy.ai/api/search-image?query=Natural%20intimate%20indoor%20setting%20with%20soft%20window%20light%2C%20warm%20cozy%20atmosphere%2C%20cinematic%20portrait%20style%2C%20gentle%20shadows%2C%20authentic%20mood%2C%20professional%20lighting&width=1200&height=600&seq=tanhua-carousel-05&orientation=landscape',
  },
];

export const aboutData = {
  title: '关于探花系列',
  content:
    '探花系列是致力于打造国内最全、最优质的国产探花视频资源聚合平台。我们深耕探花领域多年，与果冻传媒等优质内容方建立了深度合作，持续为探花爱好者提供高清、流畅、丰富的探花视频在线观看体验。平台收录的探花作品涵盖酒店探花、街拍探花、素人探花、多人探花等全类型资源，每日保持50+部的更新频率，资源总量已突破20000部。探花系列坚持人工精选与质量审核，确保每一部上架作品都值得观看，是国产探花爱好者首选的探花福利入口和探花资源合集平台。',
};

export const faqData = [
  {
    id: 'faq-1',
    q: '探花系列平台是什么？',
    a: '探花系列是一个专注国产探花视频资源聚合的免费在线平台，收录果冻传媒探花、街拍探花、酒店探花等全类型的优质探花作品，为爱好者提供一站式探花视频在线观看体验。',
  },
  {
    id: 'faq-2',
    q: '探花系列的视频画质如何？',
    a: '全站探花视频均采用高清编码，确保清晰流畅的观看体验。我们使用先进的视频压缩技术，在保证画质的前提下优化加载速度，无论桌面端还是移动端都能获得良好的探花视频观看效果。',
  },
  {
    id: 'faq-3',
    q: '如何找到最新的国产探花资源？',
    a: '您可以通过首页的「最新动态」栏目查看每日更新的探花作品，也可以在「热门榜单」中浏览当前最受欢迎的探花系列视频。此外，各个专题合集页面也按主题整理了大量探花资源供您探索。',
  },
  {
    id: 'faq-4',
    q: '探花系列平台是否需要注册或付费？',
    a: '探花系列平台完全免费开放，无需注册即可在线观看所有探花视频资源。我们致力于为国产探花爱好者提供无障碍的观看体验，不设任何付费墙或会员门槛。',
  },
];

export const appData = {
  title: '随时随地 · 探花在手',
  desc: '探花系列完美适配移动端浏览器，无需下载安装任何应用，打开手机浏览器即可畅享全部探花视频资源。收藏本站到手机桌面，一键直达探花福利入口。',
  features: ['高清自适应播放', '每日更新提醒', '全类型专题合集', '免安装即开即看'],
};

export const footerData = {
  intro: '探花系列 —— 国内领先的国产探花视频资源聚合平台，每日更新高清探花作品，提供国产探花在线免费观看、探花福利入口及探花作品大全，是本土探花爱好者的首选资源合集站。',
  columns: [
    {
      title: '探花导航',
      links: [
        { label: '国产探花系列', href: '#cards' },
        { label: '探花视频在线', href: '#media' },
        { label: '探花资源合集', href: '#index' },
        { label: '探花福利入口', href: '#contact' },
      ],
    },
    {
      title: '热门专题',
      links: [
        { label: '果冻传媒探花', href: '#carousel' },
        { label: '酒店探花实录', href: '#cards' },
        { label: '街拍探花合集', href: '#index' },
        { label: '探花作品大全', href: '#ranking' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '平台介绍', href: '#about' },
        { label: '常见问答', href: '#faq' },
        { label: '最新动态', href: '#updates' },
        { label: '联系我们', href: '#contact' },
      ],
    },
  ],
  partners: '合作伙伴',
};